<template>
  <b-row>
    <!-- Columna 1 -->
    <b-col cols="12" md="6">
      <b-row class="mb-1 justify-content-center text-center">
        <b-col class="py-2 col-6">
          <b-img class="img-bm" :src="require('@/assets/images/pdf/logo_new.png')"/>
        </b-col>
        <b-col class="col-6 p-2 d-flex flex-column align-items-center">
            <b-avatar
              :src="avatar"
              class="p-0"
              size="12rem"
            />
              <b-avatar class="icon-network" variant="ligth">
                <b-img :src="getIconWhitePng('twitter')" :class="getIconColor('twitter')" fluid/>
              </b-avatar>
            <h2 class="text-capitalize text-underline">{{ data.basic.title }}</h2>
            <p class="text-muted-left-side-analytics">{{ getFormat(data.metrics.subscribers_count.value)}} {{ $t('search_preview.totalAudience') }}</p>
            <p class="text-muted-left-side-analytics mb-1" v-if="data.features && data.features.blogger_geo && data.features.blogger_geo.data">{{ data.features.blogger_geo.data.country }}</p>
         </b-col>

      </b-row>
      <b-row class="mb-2">
        <b-col>
            <!-- Twitch grid analysis -->
          <div class="grid-analytics mb-2">
            <b-tooltip target="views-info">{{$t("profile.tooltipEr") }}</b-tooltip>
            <div class="grid-item box-style-analytics">
              <span class="text-muted-left-side-analytics">ER
                <b-badge class="badge-nivel mb-1" :style="`background-color: ${$t(`profile.colorsMark.${er.mark}`).color}`">{{ $t(`profile.colorsMark.${er.mark}`).text }}</b-badge>
                <b-icon
                  icon="question-circle"
                  id="views-info"
                  class="class-question"
                ></b-icon
              ></span>
              <span class="title-result">{{er.value}}{{ er.value && '%' }}</span>
            </div>

            <div class="grid-item box-style-analytics">
              <b-tooltip target="transmission-info">{{$t("profile.tooltipFrecueny")}}</b-tooltip> 
              <span class="text-muted-left-side-analytics">{{ $t('profile.tweetsFrecuency') }}
                <b-icon
                  icon="question-circle"
                  id="transmission-info"
                  class="class-question"
                ></b-icon
              ></span>
              <span class="title-result">{{ mediaPerWeek }}</span>
            </div>

            <div class="grid-item box-style-analytics">
              <b-tooltip target="active-info">{{$t("profile.tooltipTuits")}}</b-tooltip>
              <span class="text-muted-left-side-analytics">{{ $t('profile.mentionNumber') }}
                <b-icon
                  icon="question-circle"
                  id="active-info"
                  class="class-question"
                ></b-icon
              ></span>
              <span class="title-result">{{bloggerMentions}}</span>
            </div>

            <div class="grid-item box-style-analytics">
              <span class="text-muted-left-side-analytics d-flex align-items-center">{{ $t('instagram.anualGrowth') }}
                <b-badge class="badge-nivel" :style="`background-color: ${$t(`profile.colorsMark.${subscribersGrowth.mark}`).color}`">{{ $t(`profile.colorsMark.${subscribersGrowth.mark}`).text }}</b-badge>
              </span>
              <span class="title-result">{{subscribersGrowth.value}}{{ subscribersGrowth.value && "%" }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Columna 2 -->
    <b-col cols="12" md="6" class="background-small">
      <b-row class="m-1">
        <div class="box-style-analytics col-12">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">

              <b-media vertical-align="center" class="d-flex align-items-center media-user-search">
                <template #aside>
                  <div class="position-relative w-100">
                    <b-avatar
                      size="md"
                      variant="light-primary"
                      class="main-avatar"
                      :src="avatar"
                    />
                      <b-avatar size="16px" class="container-avatar-table-icon" variant="light">
                        <b-img :src="getIconWhitePng('twitter')" :class="getIconColor('twitter', false)" fluid/>
                      </b-avatar>
                  </div>
                </template>
              </b-media>
            
              <h4 class="text-blue text-underline cursor-pointer f16 m-0 ml-05">@{{data.basic.username }}</h4>
            </div>
            
            <div class="avenir-medium">
              {{ getFormat(data.metrics.subscribers_count.value) }} {{ $t('campaigns.followers') }}
              <b-button variant="outline-secondary-custom-analysis" @click="redirectToSocialNet('twitter', data.basic.username)" class="outline-secondary-custom-analysis ml-05">
                <feather-icon icon="ExternalLinkIcon" size="21"></feather-icon>
              </b-button>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="mb-2">
        <b-col class="py-2">
          <tweets-feature :tweets="data.features.last_media" v-if="data" class="mb-2"></tweets-feature>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" v-if="!printing && !is_web" class="text-right">
          <b-button
            variant="primary"
            class="hide-sm"
            @click="print()"
          >
            {{$t('printSummary')}}
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BButton, BAvatar, BImg, BIcon, BBadge, BTooltip, BMedia } from 'bootstrap-vue'
import { print, getMotivationalPhrase } from '@/libs/utils/others';
import { getIconWhitePng, getIconColor } from "@/libs/utils/icons";
import { getFormat, urlImagetoBase64, getFormattedDateTime} from '@/libs/utils/formats';
import { redirectToSocialNet } from "@/libs/utils/urls";

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    avatar: {
      type: String,
      default: () => ''
    },
    format: {
      type: String,
      default: 'pdf'
    },
    is_web: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BRow,
    BCol,
    BButton,
    BAvatar,
    BImg,
    BTooltip,
    BBadge,
    BIcon,
    BMedia,
    TweetsFeature: () => import('@/views/components/sidebar/twitter/TweetsFeature.vue'),
  },
  data () {
    return {
      redirectToSocialNet,
      getIconWhitePng,
      getIconColor,
      getMotivationalPhrase,
      urlImagetoBase64,
      getFormat,
      printing: false,
      print_image: require('@/assets/images/logo/logo_print.png'),
      src_img: '',
      interval_loading: null
    }
  },
  created() {
    const self = this;
    setTimeout(function() {
      if (!self.is_web) self.print()
    }, 100);

    urlImagetoBase64(this.print_image, function (result) {
      self.src_img = result
    });
  },
  methods: {
    print() {
      this.printing = true;
      const self = this;
      this.$emit('toogleIconClose', true)
      const name_file = `BrandMe Resumen Metricas ${self.$route.params.alias} ${self.$route.params.network} ${getFormattedDateTime()}`
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      setTimeout(function() {
        print('l', name_file, self.$parent.$parent.$refs.body, function () {
          self.printing = false;
          clearInterval(self.interval_loading)
          self.$vs.loading.close()
          self.$emit('toogleIconClose', false)
          self.$emit('closeModal')
        }, self.format)
      }, 500);
    }
  },
  computed: {
    er() {
      return this.data?.metrics?.er || this.$t('search_preview.notAvailable');
    },
    mediaPerWeek() {
      return this.data?.metrics?.media_per_week?.value || this.$t('search_preview.notAvailable');
    },
    bloggerMentions() {
      return this.data?.features?.blogger_mentions?.data?.mentions?.value || this.$t('search_preview.notAvailable');
    },
    subscribersGrowth() {
      return this.data?.metrics?.subscribers_growth_prc?.performance?.["365d"] || this.$t('search_preview.notAvailable');
    }

  }
}
</script>

<style scoped lang="scss">
  .container-avatar-table-icon {
    position: absolute; 
    bottom: -2px; 
    right: 0;
  }
  .img-bm {
    width: 100%;
    height: auto;
    max-width: 200px;
  }
  .text-muted-left-side-analytics {
    font-size: 16px;
    font-family: 'avenir-medium';
    color: #718096;
    margin-bottom: 0.3em;
  }

.icon-arrows-prices {
  color: #687385;
  margin-right: 0.5em;
  margin-top: 0.2em;
}
.icon-coin {
  width: 20px;
  height: 20px;
}
.grid-analytics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  @media (max-width: 690px) {
    grid-template-columns: repeat(1, 1fr);
  }


  .badge-nivel {
    font-family: 'avenir-medium' !important;
    font-size: 14px;
    margin-left: 0.5em;
    line-height: 1.3;
    font-weight: 500;
  }
  .title-result {
    font-size: 20px;
    width: 100%;
    display: block;
  }
}
.class-question {
  cursor: pointer;
  margin-left: 10px;
}
.box-style-analytics {
  border-radius: 6px;
  box-shadow: 0 1px 4px #0b14260a;
  padding: 20px;
  background-color: white;
  border: 1px solid #E2E8F0;

  .f16 {
    font-size: 16px;
  }
  .grid-inner-box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    .inner-box {
      border: 1px solid #E2E8F0;
      border-radius: 6px;
      box-shadow: 0 1px 4px #0b14260a;
      padding: 16px;
    }
  }
  .outline-secondary-custom-analysis {
    background: white;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 4px;
    padding: 8px 5px;
    border-radius: 8px;
    .icon-external {
      font-size: 30px;
    }
  }
}
.ml-05 {
  margin-left: 0.5em;
}
.mr-05 {
  margin-right: 0.5em;
}
.icon-network {
  position: relative;
  width: 38px !important;
  height: 38px !important;
  left: 40px;
  bottom: 35px;
}
.background-small {
  background-color: #F5F8FA;
  border-left: 1px solid #e2e8f0;
}
</style>
